import React, {Component} from 'react';
import s from './Slider.css';
import PropTypes from "prop-types";
import Button from "./Button/Button";
import withStyles from "isomorphic-style-loader/withStyles";

class Slider extends Component {

    constructor(props) {
        super(props);

        this.state = {
            index: typeof this.props.defaultIndex !== 'undefined' ? this.props.defaultIndex : 0
        };
    }

    /**
     * Получить следующий индекс слайдера
     * @returns {*}
     */
    getNextIndex() {
        let next = this.state.index + 1;

        if (next >= this.props.children.length) {
            next = 0;
        }

        return next;
    }

    onChange(index) {
        this.setState({ index: index });
    }

    renderButtons() {
        let buttons = [];

        for (let i = 0; i < this.props.children.length; i++) {
            buttons.push(<Button onClick={this.onChange.bind(this, i)} active={i === this.state.index} key={`slider-button${i}`}/>)
        }

        return buttons;
    }

    renderSlide() {
        let slide = this.props.children.filter((item, i) => { return i === this.state.index; });

        if (!slide.length) {
            return (<div>No slide</div>);
        }

        return React.cloneElement(slide[0], {
            className: s.slide,
            onClick: this.onChange.bind(this, this.getNextIndex())
        });
    }

    render() {
        return (
            <div className={s.root}>
                {this.renderSlide()}

                {this.renderButtons()}
            </div>
        );
    }
}

Slider.propTypes = {
    children: PropTypes.array.isRequired
};


export default withStyles(s)(Slider);

